import {create} from 'zustand';
import {DocumentData, DocumentSnapshot} from 'firebase/firestore';

type PostsStore = {
	posts: DocumentSnapshot<DocumentData, DocumentData>[] | null;
	setPosts: (
		newPosts: DocumentSnapshot<DocumentData, DocumentData>[] | null,
	) => void;

	lastVisiblePost: DocumentSnapshot<DocumentData, DocumentData> | null;
	setLastVisiblePost: (
		newLastVisiblePost: DocumentSnapshot<DocumentData, DocumentData> | null,
	) => void;

	loadedAllPosts: boolean;
	setLoadedAllPosts: (loadedAllPosts: boolean) => void;
};

export const usePostsStore = create<PostsStore>((set) => ({
	posts: null,
	setPosts: (
		newPosts: DocumentSnapshot<DocumentData, DocumentData>[] | null,
	) => {
		set(() => ({posts: newPosts}));
	},

	lastVisiblePost: null,
	setLastVisiblePost: (
		newLastVisiblePost: DocumentSnapshot<DocumentData, DocumentData> | null,
	) => {
		set(() => ({lastVisiblePost: newLastVisiblePost}));
	},

	loadedAllPosts: false,
	setLoadedAllPosts: (newLoadedAllPosts: boolean) => {
		set(() => ({loadedAllPosts: newLoadedAllPosts}));
	},
}));
